import { Outlet } from '@remix-run/react'
import { Container } from '#app/components/layout/container.js'
import { RemixBreadcrumbs } from '#app/components/navigation/remix-breadcrumbs.js'

export const handle = {
	breadcrumb: 'Articles',
}

const ArticlesLayoutRoute = () => {
	return (
		<Container>
			<RemixBreadcrumbs />
			<Outlet />
		</Container>
	)
}
export default ArticlesLayoutRoute
